import { render, staticRenderFns } from "./AppointmentsItemRequestView.vue?vue&type=template&id=436eb06f&scoped=true&"
import script from "./AppointmentsItemRequestView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsItemRequestView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsItemRequestView.vue?vue&type=style&index=0&id=436eb06f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436eb06f",
  null
  
)

export default component.exports